<template>
  <div class="px-4 sm:px-6 lg:px-16 max-w-screen-xl lg:mx-auto">
    <HeaderApp />
    <div class="flex justify-center">
      <h2 class="text-lg">Filtering {{ title }}</h2>
    </div>
    <Filters
      :active_filters="viewInfo"
      :origin="origin"
      class="flex flex-col gap-y-4 xl:gap-y-0"
    />
    <router-link :to="{ name: goTo }">
      <Button block>
        Filter
      </Button>
    </router-link>
  </div>
</template>

<script>
import HeaderApp from "@/components/Header";
import Filters from "@/components/Filters";
import Button from "@/components/UI/Button";
import { useRouter } from "vue-router";
import { onBeforeMount, ref } from "vue";
export default {
  components: { HeaderApp, Filters, Button },
  setup() {
    const router = useRouter();
    let viewInfo = ref({});
    let origin = ref("");
    let goTo = ref("");
    let title = ref("");
    onBeforeMount(async () => {
      // const pagesIgnorePath = ["Tiktoks", "top-brands", "Library"];
      // const pageCheckIgnore = pagesIgnorePath.includes(
      //   router.currentRoute.value.params.pageName
      // );
      if (router.currentRoute.value.params.pageName === "FbAndIg") {
        viewInfo.value = await {
          industry: true,
          objective: true,
          type: true,
          format: true,
        };
        origin.value = await "fb-and-ig";
        title.value = "Fb and IG adsssss";
        goTo.value = router.currentRoute.value.params.pageName;
      } else if (router.currentRoute.value.params.pageName === "Tiktoks") {
        viewInfo.value = await {
          industry: true,
          objective: false,
          type: false,
          format: false,
        };
        origin.value = await "tiktoks";
        title.value = "Tiktoks";
        goTo.value = router.currentRoute.value.params.pageName;
      } else if (router.currentRoute.value.params.pageName === "top-brands") {
        viewInfo.value = await {
          country: true,
          industry: true,
        };
        origin.value = await "topbrands";
        title.value = "Top Brands";
        goTo.value = router.currentRoute.value.params.pageName;
      } else if (router.currentRoute.value.params.pageName === "UGC Creators") {
        viewInfo.value = await {
          industry: true,
          objective: false,
          type: false,
          format: false,
        };
        origin.value = await "ugc-creators";
        title.value = "UGC Creators";
        goTo.value = router.currentRoute.value.params.pageName;
      } else {
        viewInfo.value = await {
          industry: true,
          objective: true,
          type: true,
          format: true,
        };
        origin.value = await "fb-and-ig";
        goTo.value = "FbAndIg";
        title.value = "Fb and IG ads";
      }
    });
    return { viewInfo, origin, goTo, title };
  },
};
</script>
